// @ts-strict-ignore
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';

import { useCmsApiPageSubsite } from './useCmsApiPageSubsite';

type Props = {
  cmsApiPage: CmsApiPage;
};

export function useCmsApiPageHomePageMeta({ cmsApiPage }: Props) {
  const subsite = useCmsApiPageSubsite({ cmsApiPage });
  const hasHomePage = !!cmsApiPage.subsite.homePage;
  const subsiteHasHomePage = hasHomePage || !!subsite.homePage;
  const homePageUrl = subsite.homePage ? subsite.homePage.url : '';

  return { hasHomePage, subsiteHasHomePage, homePageUrl };
}
